module.exports = __webpack_public_path__ + "fonts/opensans-light-webfont.fa961b4e.ttf";